import { useEffect, useState } from 'react';
import api from '@/shared/api/client';

/**
 * Les modules souscrits par le sous-compte courant.
 *
 * Sert à ne PAS proposer ce qui n'est pas souscrit. La protection, elle, est posée côté
 * serveur : masquer une entrée de menu n'a jamais empêché personne de taper une URL.
 *
 * Tant que la réponse n'est pas arrivée, `pret` vaut false et l'appelant montre tout —
 * mieux vaut un menu complet une demi-seconde qu'un menu qui se remplit sous les yeux.
 */
export default function useModules() {
  const [modules, setModules] = useState(null);
  const [pret, setPret] = useState(false);

  useEffect(() => {
    let vivant = true;
    api.get('/auth/me/modules')
      .then((r) => { if (vivant) setModules(r.data?.modules || null); })
      .catch(() => { /* le serveur tranche de toute facon : on n'affole pas l'ecran */ })
      .finally(() => { if (vivant) setPret(true); });
    return () => { vivant = false; };
  }, []);

  const souscrit = (module) => !module || !modules || modules.includes(module);
  return { modules, pret, souscrit };
}
